export const getVendorNameFromRegistry = (registry) =>
  registry?.vendorName || registry?.vendor_name || registry?.name;
